export default __webpack_public_path__ + "static/media/download.de84666d.svg";